import { ProductType } from '@/types';
import { getDefaultAppearanceId } from './getDefaultAppearanceId';

export const getAppearance = (
  productType: ProductType,
  appearanceId: string = getDefaultAppearanceId(productType)
) => productType.appearances.find(({ id }) => id === appearanceId);
